jQuery(function ($) {

    const observer = new MutationObserver(function () {
        $('shopify-forms-embed').each(function () {
            const shadow = this.shadowRoot;
            if (!shadow) return;

            $(shadow).find('._textBody_2aowh_10').each(function () {
                const textContent = $(this).text();
                if (textContent.includes('<a ') && textContent.includes('</a>')) {
                    $(this).html(textContent);
                }
            });

            $(shadow).find('legend').css('display', 'none');

            $(shadow).find('fieldset[name="custom#stay_updated_with_our_latest_news"]').css('padding-bottom', '30px');
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

});
